import React from "react";

import dayjs from "dayjs";

import {CircularProgress, Stack} from "@mui/joy";
import Chip from "@mui/joy/Chip";
import Divider from "@mui/joy/Divider";
import Card from "@mui/joy/Card";

// components
import BaseApi from "../../utils/BaseApi";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import Typography from "@mui/joy/Typography";


class OpportunityEvaluationCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            report: null,
            certificates: null,
            calendarFull: null,
            calendarNormal: null,
            phases: null,
        };
    }

    async componentDidMount() {
        await this.retrieveReport();
        await this.retrieveCertificates();
        await this.retrieveCalendar();
        await this.retrievePhases();
    }

    async retrievePhases() {
        this.setState(
            {
                phases: null,
            }
        );
        let phasesPermission = await retrievePermission(
            'PhaseViewSet',
            'list',
            this.context.subscriberObject
        );
        if (phasesPermission){
            const api = new BaseApi();
            let url = 'phase'
            let response = await api.get(url, {
                opportunity: this.props.opportunity.id
            });
            let phases = response.data.results
            this.setState({
                phases: phases,
            })
        }
        else {
            this.setState({
                phases: [],
            })
        }

    }

    async retrieveReport(){
        let url = `opportunity/${this.props.opportunity.id}/evaluation`;
        const api = new BaseApi();
        let params = {
        };
        let response = await api.get(
            url,
            params
        );
        if (response.status === 200) {
            this.setState(
                {
                    report: response.data
                }
            );
        }
    }

    async retrieveCalendar() {
        this.setState(
            {
                calendarFull: null,
                calendarNormal: null,
            }
        );
        let calendarPermission = await retrievePermission(
            'OpportunityViewSet',
            'calendar',
            this.context.subscriberObject
        );
        if (calendarPermission){
            const url = `opportunity/${this.props.opportunity.id}/calendar`;
            const api = new BaseApi();
            let response = await api.get(url, {});
            let calendarNormal = response.data.calendar ;
            let params = {
                norma: 100,
            }
            response = await api.get(url, params);
            let calendarFull = response.data.calendar ;
            this.setState(
                {
                    calendarFull: calendarFull,
                    calendarNormal: calendarNormal,
                }
            );
        }
        else {
            this.setState(
                {
                    calendarFull: [],
                    calendarNormal: []
                }
            );
        }
    }

    async retrieveCertificates() {
        this.setState(
            {
                certificates: null
            }
        );
        let certificateListPermission = await retrievePermission(
            'OppCertViewSet',
            'list',
            this.context.subscriberObject
        );
        if (certificateListPermission){
            const url = 'certificate/';
            const api = new BaseApi();
            let params = {
                page_size: 10000,
                opportunity: this.props.opportunity.id,
            }
            let response = await api.get(
                url,
                params
            );
            this.setState(
                {
                    certificates: response.data.results,
                }
            );
        }
        else {
            this.setState(
                {
                    certificates: []
                }
            );
        }

    }

    render() {
        if (!this.state.report || !this.state.certificates || !this.state.calendarNormal || !this.state.calendarFull || !this.state.phases ) {
            return (<CircularProgress/>)
        }
        let delta = this.state.report.total_workloads.max_proba_estimation - this.state.report.total_workloads.workload_fact_estimation - this.state.report.to_go
        let deltaNormal = this.state.report.total_workloads.normal_estimation - this.state.report.total_workloads.workload_fact_estimation - this.state.report.to_go
        return (
            <Card
                size={'sm'}
                sx={{
                    maxWidth: '100%'
                }}
            >
                <Stack
                    spacing={1}
                >
                    <Chip
                        size={'sm'}
                        color={'primary'}
                    >
                        Оценка (вер.): {this.state.report.total_workloads.max_proba_estimation}
                    </Chip>
                    <Chip
                        size={'sm'}
                        color={'primary'}
                    >
                        Оценка (норм.): {this.state.report.total_workloads.normal_estimation}
                    </Chip>
                    <Chip
                        size={'sm'}
                        color={'primary'}
                    >
                        Факт: {Math.trunc(this.state.report.total_workloads.workload_fact_estimation)} ({Math.trunc(this.state.report.total_workloads.workload_fact_not_estimation)})
                    </Chip>
                    <Chip
                        size={'sm'}
                        color={'pink'}
                    >
                        Впереди: {this.state.report.to_go} + &#9888;{this.state.report.to_go_waste}
                    </Chip>
                    <Chip
                        size={'sm'}
                        color={'indigo'}
                    >
                        Общая: {this.state.report.total_workloads.workload_fact_estimation + this.state.report.to_go}
                    </Chip>
                    <Chip
                        size={'sm'}
                        color={delta > 0?'success':'danger'}
                    >
                        Разница (вер): {Math.trunc(delta)}
                    </Chip>
                    <Chip
                        size={'sm'}
                        color={deltaNormal > 0?'success':'danger'}
                    >
                        Разница (норм): {Math.trunc(deltaNormal)}
                    </Chip>
                    {
                        this.state.phases.length?
                            <>
                                <Divider />
                                    <Typography
                                        level={'body-sm'}
                                    >
                                        Этапы договора
                                    </Typography>
                                    {
                                        this.state.phases.map((p)=>(
                                            <Chip
                                                size={'sm'}
                                                color={'primary'}
                                            >
                                                {p.end_date?dayjs(p.end_date).format('DD MMM YYYY'):p.end_date}
                                            </Chip>
                                        ))
                                    }
                            </>:
                            null
                    }
                    {
                        this.state.certificates.length?
                            <>
                                <Divider />
                                    <Typography
                                        level={'body-sm'}
                                    >
                                        Акты
                                    </Typography>
                                    {
                                        this.state.certificates.map((c)=>(
                                            <Chip
                                                size={'sm'}
                                                color={c.approval?'success':'primary'}
                                            >
                                                {c.date?dayjs(c.date).format('DD MMM YYYY'):c.date}
                                            </Chip>
                                        ))
                                    }
                            </>:
                            null
                    }
                    {
                        this.state.calendarFull.length || this.state.calendarNormal.length?
                            <>
                                <Divider />
                                    <Typography
                                        level={'body-sm'}
                                    >
                                        Прогноз загрузки
                                    </Typography>
                                    {
                                        (this.state.report.to_go + this.state.report.to_go_waste)?
                                            <>
                                                <Chip
                                                    size={'sm'}
                                                >
                                                    Норма: {this.state.calendarNormal[0].length?this.state.calendarNormal[0].length - 1:0} мес. {this.state.calendarNormal[0].length?Math.ceil(this.state.calendarNormal[0][this.state.calendarNormal[0].length - 1]):Math.ceil(this.state.calendarNormal[0][0])} р. дн.
                                                </Chip>
                                                <Chip
                                                    size={'sm'}
                                                >
                                                    Предел: {this.state.calendarFull[0].length?this.state.calendarFull[0].length - 1:0} мес. {this.state.calendarFull[0].length?Math.ceil(this.state.calendarFull[0][this.state.calendarFull[0].length - 1]):Math.ceil(this.state.calendarFull[0][0])} р. дн.
                                                </Chip>
                                            </>:
                                            <Chip
                                                size={'sm'}
                                            >
                                                Проект выполнен
                                            </Chip>
                                    }
                            </>:
                            null
                    }
                </Stack>
            </Card>
        );
    }
}

export default OpportunityEvaluationCard
